// extracted by mini-css-extract-plugin
export default {"link":"_NLJ5","title":"_QYMe","title-skeleton":"gyCHN","params":"BF4_E","image":"mTb3M"};